import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import auth from '../auth';
import moment from 'moment';
import * as rmd from 'material-ui';
import _ from 'lodash';
import Promise from 'bluebird';
import loadStyle from '../../../common/loadStyle';
import SassVariablesEditor from './SassVariablesEditor';
import ThemePreview from '../../../widgets/components/common/ThemePreview';
import WidgetsPreview from '../../../widgets/components/common/WidgetsPreview';
import cx from 'classnames';
import config from 'cfg';

class Pure extends React.PureComponent {
    render() {
        return <div {...this.props}> {this.props.children}</div>;
    }
}

class ThemeCustomizer extends React.Component {
    constructor(props, context) {
        super(props, context);
        var q = props.router.location.query;

        this.state = {
            isLoading: true,
            expandedWidgetsIds: _.flatten([].concat(q.widgets || [])),
            expandedThemeSections: _.flatten([].concat(q.themSects || ['Color palette'])),
            theme: {},
            variables: {},
            showPublishedNotification: false,
            showErrorNotification: false,
            variableWithError: '',
            editVariable: null,
            stylesLoaded: false,
            spec: {
                widgets: []
            }
        };

        this.loadData();
    }
    componentDidMount() {
        const { client, username } = this.context.user;
        const { themeId } = this.props.params;

        loadStyle(`${config.assets}/css/clients/${client}.${username}.${themeId}.css`, () => {
            this.setState({ stylesLoaded: true });
        });
    }
    static contextTypes = {
        user: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired
    };

    loadData() {
        const { _id: userId, client } = this.context.user;
        const { themeId } = this.props.params;
        const token = auth.getAccessToken();
        return Promise.props({
            theme: fetch(`${config.dash.api.host}/api/themes/${themeId}?access_token=${auth.getAccessToken()}`).then(
                response => response.json()
            ),
            spec: fetch(`${config.dash.api.host}/api/widgets/spec?access_token=${auth.getAccessToken()}`)
                .then(response => response.json())
                .then(spec => {
                    spec.widgets = _.filter(spec.widgets, w => w.spec && !w.spec.social);
                    return spec;
                }),
            variables: fetch(
                `${config.dash.api.host}/api/themes/ui-variables?access_token=${auth.getAccessToken()}`
            ).then(response => response.json()),
            userImages: fetch(`${config.dash.api.host}/api/media?access_token=${token}`).then(response =>
                response.json()
            )
        })
            .then(results => {
                this.setState({ ...results, isLoading: false });
            })
            .catch(e => {
                console.error(e);
                this.setState({
                    error: e,
                    isLoading: false
                });
            });
    }

    handleSave = variables => {
        const { username: user, client, _id } = this.context.user;
        const { themeId: theme } = this.props.params;

        return Promise.props({
            saveUserVariables: fetch(`/api/themes/${theme}?access_token=${auth.getAccessToken()}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    userVariables: variables
                })
            }).then(response => {
                let { status } = response;

                if (status === 200) {
                    return response.json();
                }
            })
        });
    };

    handlePublish = variables => {
        const { _id: userId } = this.context.user;
        const { themeId } = this.props.params;

        return this.handleSave(variables).then(() => {
            return fetch(
                `${config.dash.api.host}/api/themes/${themeId}/publish-styles?access_token=${auth.getAccessToken()}`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        variables
                    })
                }
            )
                .then(response => {
                    let { status } = response;
                    if (status === 200) {
                        return response.json();
                    }
                })
                .then(uploadInfo => {
                    this.setState({ ...uploadInfo, showPublishedNotification: true });
                    this.loadData();
                    return { saved: true, publishing: false };
                });
        });
    };

    handleReset = () => {};

    handleWidgetsCollapseChange = expandedWidgetsIds => {
        this.setState(
            {
                expandedWidgetsIds: expandedWidgetsIds
            },
            () => {
                this.context.router.replace({
                    ...this.props.location,
                    query: {
                        themSects: this.state.expandedThemeSections,
                        widgets: this.state.expandedWidgetsIds
                    }
                });
            }
        );
    };

    handleThemeCollapseChange = indexes => {
        this.setState(
            {
                expandedThemeSections: indexes
            },
            () => {
                this.context.router.replace({
                    ...this.props.location,
                    query: {
                        themSects: this.state.expandedThemeSections,
                        widgets: this.state.expandedWidgetsIds
                    }
                });
            }
        );
    };
    handleEditVariableChange = editVariable => {
        this.setState({ editVariable });
    };
    handleVariablesUpdate = (variables, changedVariable) => {
        const { username: user, client, _id: userId } = this.context.user;
        const { themeId } = this.props.params;

        return fetch(
            `${config.dash.api.host}/api/themes/${themeId}/generate-styles?access_token=${auth.getAccessToken()}`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json' //this causes method to be OPTIONS, but without it variables are not passed to request...
                },
                body: JSON.stringify({
                    variables
                })
            }
        )
            .then(response => response.text())
            .then(text => {
                if (text === 'error') {
                    this.setState({
                        showErrorNotification: true,
                        variableWithError: changedVariable
                    });
                    return { error: true, variable: changedVariable };
                }
                return text;
            })
            .catch(e => console.error('Could not compile, catch in ThemeCustomizer', e));
    };

    handleImagePickerRequest = name => {
        this.setState({
            imagePickerFor: name
        });
    };

    handleCssUpdated = () => {
        //This dispatch is needed when we need to change color of something in JS (for example, Canvas)
        window.dispatchEvent(new Event('resize'));
    };

    render() {
        const { isLoading, theme, spec, variables, cssUrl, stylesLoaded, userImages } = this.state;
        const { themeId } = this.props.params;
        const { user } = this.context;
        const { userVariables } = theme;
        //TODO:PACKAGES
        const widgets = spec.widgets.filter(w => {
            return this.state.expandedWidgetsIds.indexOf(w.id) !== -1;
        });

        const sassEditorClasses = cx('wdp-saas-editor-container', {
            'wdp-saas-editor-container_modal-is-open': this.state.imagePickerFor
        });

        return (
            <div className={`theme-customizer-container`}>
                <Pure className={sassEditorClasses}>
                    {!isLoading &&
                        !_.isEmpty(userVariables) && (
                            <div>
                                <h2>Theme: {theme.name}</h2>
                                <SassVariablesEditor
                                    error={this.state.error}
                                    themeId={themeId}
                                    variables={variables}
                                    userImages={userImages}
                                    userVariables={userVariables}
                                    sectionsToShow={this.state.expandedThemeSections}
                                    widgetsToShow={this.state.expandedWidgetsIds}
                                    onSave={this.handleSave}
                                    onPublish={this.handlePublish}
                                    onReset={this.handleReset}
                                    onWidgetsCollapseChange={this.handleWidgetsCollapseChange}
                                    onThemeCollapseChange={this.handleThemeCollapseChange}
                                    onVariablesUpdate={this.handleVariablesUpdate}
                                    onEditVariableChange={this.handleEditVariableChange}
                                    onImagePickerRequest={this.handleImagePickerRequest}
                                    onCssUpdated={this.handleCssUpdated}
                                    router={this.props.router}
                                    route={this.props.route}
                                />
                                <br />
                                <div>
                                    <pre>
                                        <a href={theme.cssUrl}>{theme.cssUrl}</a>
                                    </pre>
                                    <pre>id: {theme.id}</pre>
                                    <pre>client: {user.client}</pre>
                                    <pre>user: {user.username}</pre>
                                    <pre>created: {moment(theme.createdAt).format('HH:mm, DD MMMM')}</pre>
                                    <pre>updated: {moment(theme.updatedAt).format('HH:mm, DD MMMM')}</pre>
                                </div>
                            </div>
                        )}
                    {cssUrl && (
                        <rmd.Card className="card rlz-theme-customizer__block">
                            <a style={{ wordBreak: 'break-all' }} href={cssUrl}>
                                {cssUrl}
                            </a>
                        </rmd.Card>
                    )}
                </Pure>
                <div
                    className={cx('card wdp-preview-container', 'rlz-theme-customizer__block', {
                        'wdp-preview-container_modal-is-open': this.state.imagePickerFor
                    })}
                >
                    <div className="preview">
                        {stylesLoaded &&
                            this.state.expandedThemeSections.length > 0 && (
                                <ThemePreview
                                    theme={themeId}
                                    editVariable={this.state.editVariable}
                                    sectionsToShow={this.state.expandedThemeSections}
                                />
                            )}
                        {stylesLoaded && (
                            <WidgetsPreview
                                token={this.context.user.accessToken}
                                user={this.context.user.username}
                                client={this.context.user.client}
                                theme={themeId}
                                widgets={widgets}
                            />
                        )}
                    </div>
                </div>

                <rmd.Snackbar
                    open={this.state.showPublishedNotification}
                    message="CSS was successfully published."
                    autoHideDuration={4000}
                    onRequestClose={() => this.setState({ showPublishedNotification: false })}
                />

                <rmd.Snackbar
                    open={this.state.showErrorNotification}
                    message={`Error. Wrong variable ${this.state.variableWithError} value.`}
                    autoHideDuration={4000}
                    bodyStyle={{ backgroundColor: 'rgba(198,40,40,0.8)' }}
                    onRequestClose={() => this.setState({ showErrorNotification: false })}
                />
            </div>
        );
    }
}

export default ThemeCustomizer;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/ThemeCustomizer.js
 **/